exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  overflow-y: scroll;\n  font-family: 'Roboto', sans-serif; }\n\nbutton, select {\n  font-family: inherit; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app.scss
// module id = 955
// module chunks = 1